import {
  GenerationStatus,
  GetSuggestedGenerationStatusResponse,
} from '@fullstory/proto/fs/services/llm-tool';
import { Timestamp } from '@fullstory/proto/google/protobuf';
import { createRequestReducer, RequestState } from '@fullstory/redux-util';
import { combineReducers } from 'redux';
import { AssistantActions, LlmAutoconfigureRequestActions } from './actions';
import { AssistantTypes, LlmAutoconfigureRequestTypes } from './types';

export const getSuggestedGenerationStatus =
  createRequestReducer<GetSuggestedGenerationStatusResponse>()(
    LlmAutoconfigureRequestTypes.GetSuggestedGenerationStatusRequest,
    LlmAutoconfigureRequestTypes.GetSuggestedGenerationStatusSuccess,
    LlmAutoconfigureRequestTypes.GetSuggestedGenerationStatusFailure,
  );

const defaultState: RequestState<GetSuggestedGenerationStatusResponse> = {
  lastRequested: -1,
  lastResponded: -1,
  loading: false,
  error: false,
  safeMessage: null,
  data: {
    generationStatus: GenerationStatus.GENERATIONSTATUS_READY,
    lastUpdated: null,
    attributeStatus: GenerationStatus.GENERATIONSTATUS_READY,
    attributeLastUpdated: null,
    mlPageSpecStatus: GenerationStatus.GENERATIONSTATUS_READY,
    mlPageSpecLastUpdated: null,
    pageStatus: GenerationStatus.GENERATIONSTATUS_READY,
    pageLastUpdated: null,
  },
};

export const suggestedGenerationStatus = (
  state = defaultState,
  action: LlmAutoconfigureRequestActions & { sequenceNumber: number },
): ReturnType<typeof getSuggestedGenerationStatus> => {
  // ) => {
  switch (action.type) {
    case LlmAutoconfigureRequestTypes.KickstartSuggestedElementsSuccess:
      return {
        ...state,
        data: {
          generationStatus: GenerationStatus.GENERATIONSTATUS_GENERATING,
          lastUpdated: Timestamp.now(),
          attributeStatus: GenerationStatus.GENERATIONSTATUS_READY,
          attributeLastUpdated: null,
          mlPageSpecStatus: GenerationStatus.GENERATIONSTATUS_READY,
          mlPageSpecLastUpdated: null,
          pageStatus: GenerationStatus.GENERATIONSTATUS_READY,
          pageLastUpdated: null,
        },
      };
    case LlmAutoconfigureRequestTypes.GetSuggestedGenerationStatusRequest:
    case LlmAutoconfigureRequestTypes.GetSuggestedGenerationStatusSuccess:
    case LlmAutoconfigureRequestTypes.GetSuggestedGenerationStatusFailure:
      return getSuggestedGenerationStatus({ ...state }, action);
    default:
      return state;
  }
};

type LlmToolReducerState = {
  suggestedGenerationStatus: ReturnType<typeof getSuggestedGenerationStatus>;
};

export const llmToolReducer = combineReducers<LlmToolReducerState>({
  suggestedGenerationStatus,
});

type AssistantState = { session: { sessionEvents: string; userId: string; sessionId: string } };

export function assistantReducer(
  state: AssistantState = { session: { sessionEvents: '', userId: '', sessionId: '' } },
  action: AssistantActions,
): AssistantState {
  switch (action.type) {
    case AssistantTypes.SetSessionContext:
      if (action.sessionEvents) {
        return {
          session: {
            sessionEvents: action.sessionEvents,
            userId: action.userId,
            sessionId: action.sessionId,
          },
        };
      }
  }
  return state;
}
